module.exports = __webpack_public_path__ + "static/media/logo2.de075e60.png";